export default __webpack_public_path__ + "media/images/ui-icons_777620_256x240-8003dc8c.png";